import { AsyncPipe, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { PaymentCardFormComponent } from '@components/consultation-request/payment-card-form/payment-card-form.component';
import { PaymentSubmitButtonComponent } from '@components/consultation-request/payment-submit-button/payment-submit-button.component';
import { OrderFlowUpsellComponent } from '@components/order-flow-upsell/order-flow-upsell.component';
import { PartialResultsDeliveryUpsell } from '@data/tests';
import { OrderUpsell } from '@models/order-upsell';
import { PartialResultsDeliveryResponse } from '@models/partial-results-delivery-response';
import { ImageFallback } from '@pipes/image-fallback';
import { PartialResultsDeliveryService } from '@services/partial-results-delivery.service';
import { provideDefaultPaymentConfig } from '@services/payment.service';

@Component({
  selector: 'app-partial-results-delivery',
  templateUrl: './partial-results-delivery.component.html',
  styleUrls: ['./partial-results-delivery.component.scss'],
  imports: [
    NgIf,
    CardComponent,
    NgFor,
    PaymentCardFormComponent,
    PaymentSubmitButtonComponent,
    AsyncPipe,
    ImageFallback,
    NgOptimizedImage,
  ],
  providers: [provideDefaultPaymentConfig()],
})
export class PartialResultsDeliveryComponent extends OrderFlowUpsellComponent implements OnInit {
  public override readonly upsellTest: OrderUpsell = PartialResultsDeliveryUpsell;
  public partialResultsDeliveryContent: PartialResultsDeliveryResponse;

  private partialResultsDeliveryService = inject(PartialResultsDeliveryService);

  /**
   * Gets the price of the PartialResultsDelivery test.
   */
  public get partialResultsDeliveryPrice(): number {
    return Number(this.partialResultsDeliveryContent.price);
  }

  /**
   * Initializes the component.
   */
  public ngOnInit(): void {
    this.getPartialResultsDeliveryContent();
  }

  /** {@inheritDoc OrderFlowUpsellComponent.onUpsellSuccess} */
  protected override onUpsellSuccess(): void {
    this.processing = false;
    this.navigateToNextPage();
  }

  /**
   * Gets the content for the PartialResultsDelivery test.
   */
  private getPartialResultsDeliveryContent(): void {
    this.loadingService.toggleLoader(true);
    this.partialResultsDeliveryService.getPartialResultsDeliveryContent().subscribe({
      next: (response) => {
        this.partialResultsDeliveryContent = response;
        this.loadingService.toggleLoader(false);
      },
      error: () => {
        this.loadingService.toggleLoader(false);
        setTimeout(() => this.navigateToNextPage(), 0);
      },
    });
  }
}
